import { blogCategories } from './blog-categories';

type BlogBreadcrumb = { label: string; href: string };

/** One hierarchy for the visible navigation and search-engine structured data. */
export function getBlogBreadcrumbs(
  categoryLabel?: string,
  article?: { title: string; href: string }
): BlogBreadcrumb[] {
  const items: BlogBreadcrumb[] = [{ label: 'Blog', href: '/blog' }];
  const category = blogCategories.find((item) => item.label === categoryLabel);
  if (category) items.push({ label: category.label, href: category.href });
  if (article) items.push({ label: article.title, href: article.href });
  return items;
}
